<template>
  <div>
    <hs-breadcrumb :breadcrumb="breadcrumb"></hs-breadcrumb>
    <Card :bordered="false" :style="{marginBottom:'10px'}">
      <div class="hs-screen-row">
        <Input v-model="params.realName" placeholder="联系人" clearable style="width: 200px"/>
      </div>
      <div class="hs-screen-row">
        <Button type="primary" @click="findList">查询</Button>
      </div>
      <div class="hs-screen-row">
        <Button @click="resetScreen">重置</Button>
      </div>
    </Card>

    <Card :bordered="false" :style="{marginBottom:'10px'}">
      <!--标题-->
      <div slot="title">
        <div class="hs-screen-box">
          <div>区域商户列表</div>
          <div>
            <ButtonGroup>
              <Button @click="findList">
                <Icon type="md-refresh" size="15"/>
              </Button>
              <Button @click="showAdminOpe(2)">新增区域商户</Button>
            </ButtonGroup>
          </div>
        </div>
      </div>
      <!--表格数据-->
      <Table :columns="columns" :data="data" size="small" :stripe="true" :loading="isTableLoading">

        <template slot-scope="{ row, index }" slot="isDisable">
          <Tag color="green" v-if="row.isDisable === 0" size="default">启用</Tag>
          <Tag color="volcano" v-if="row.isDisable === 1" size="default">禁用</Tag>
        </template>

        <template slot-scope="{ row }" slot="action">
<!--          <Button type="success" size="small" style="margin-right: 5px" @click="showRecharge(row)">充值-->
<!--          </Button>-->
          <Button type="primary" size="small" style="margin-right: 5px" @click="showAdminOpe(3, row)">编辑
          </Button>
          <Dropdown transfer trigger="click">
            <Button size="small">
              <Icon type="ios-more" size="22"/>
            </Button>
            <DropdownMenu slot="list">
<!--              <DropdownItem @click.native="showRecord(row)">充值记录</DropdownItem>-->
<!--              <DropdownItem @click.native="updateMessage(row)">更新消息提醒</DropdownItem>-->
              <DropdownItem v-if="row.isDisable === 0" @click.native="isDisableUser(row)">禁用
              </DropdownItem>
              <DropdownItem v-if="row.isDisable === 1" @click.native="isDisableUser(row)">启用
              </DropdownItem>
              <DropdownItem @click.native="isDelUser(row)">删除</DropdownItem>
            </DropdownMenu>
          </Dropdown>
        </template>
      </Table>
      <!--分页-->
      <div class="hs-page">
        <Page :total="total" show-sizer show-total transfer @on-change="changePage"
              @on-page-size-change="changePageSize"/>
      </div>
    </Card>

    <!--显示模态框-->
    <tenant-ope ref="tenantOpe" @changeDate="findList" :regionList="regionList"></tenant-ope>
    <recharge-ope ref="rechargeOpe" @changeDate="findList" :regionList="regionList"></recharge-ope>
    <record-ope ref="recordOpe" ></record-ope>
  </div>
</template>

<script>
import hsBreadcrumb from '@/components/hs-breadcrumb';
import tenantOpe from './components/tenant-ope';
import rechargeOpe from './components/recharge-ope';
import recordOpe from './components/record-ope';

export default {
  name: "admin",
  data() {
    return {
      total: 0,
      isTableLoading: false,
      regionList: [],
      // 参数
      params: {
        page: 1,
        rows: 10,
        realName: '',
        regionIds: [],
      },
      // 表格列
      columns: [
        {
          type: 'index',
          width: 60,
          align: 'center'
        },
        {
          title: 'ID',
          minWidth: 120,
          key: 'tenantId'
        },
        {
          title: '登录账号',
          minWidth: 120,
          key: 'username'
        },
        {
          title: '开通地区',
          minWidth: 220,
          key: 'region'
        },
        {
          title: '联系人姓名',
          minWidth: 120,
          key: 'realName'
        },
        {
          title: '联系方式',
          minWidth: 120,
          key: 'phone'
        },
        {
          title: '联系地址',
          minWidth: 120,
          key: 'address'
        },
        {
          title: '商户名称',
          minWidth: 120,
          key: 'companyName'
        },
        // {
        //   title: '余额',
        //   minWidth: 120,
        //   key: 'balance'
        // },
        {
          title: '状态',
          slot: 'isDisable',
          align: 'center',
          width: 120
        },
        {
          title: '创建时间',
          key: 'createTime',
          width: 150
        },
        {
          title: '操作',
          slot: 'action',
          width: 180,
          align: 'center',
          fixed: 'right'
        }
      ],
      // 表格数据
      data: [],
      // 面包屑
      breadcrumb: [
        {name: '首页', url: '', icon: 'ios-home-outline', size: 18},
        {name: '系统管理', url: '', icon: '', size: 0},
        {name: '区域商户列表', url: '', icon: '', size: 0}
      ]
    }
  },
  created() {
    // 租户-列表查询
    this.findList();
    // 租户-查询租户权限组，筛选条件使用
    this.findOpenCityList();
  },
  methods: {
    // 租户-列表查询
    findList() {
      this.isTableLoading = true;
      this.axios.post('/tenant/findList', this.params).then(res => {
        this.isTableLoading = false;
        if (res.status == 200) {
          this.total = res.data.total;
          this.data = res.data.rows;
        }
        if (res.status == 500) {
          this.$Notice.error({
            title: '服务器内部错误',
            desc: '查询区域商户列表接口报错',
            duration: 0
          });
        }
      })
    },
    // 租户-查询开通城市
    findOpenCityList() {
      this.isTableLoading = true;
      this.axios.post('/openCity/findOpenCityList', {
        page: 1,
        rows: 10000,
        isOpen: 1
      }).then(res => {
        this.isTableLoading = false;
        if (res.status == 200) {
          this.regionList = res.data.rows;
        }
        if (res.status == 500) {
          this.$Notice.error({
            title: '服务器内部错误',
            desc: '查询开通地区列表接口报错',
            duration: 0
          });
        }
      })
    },
    // 是否重置密码
    isResetPassword(row) {
      this.$Modal.confirm({
        title: `是否重置区域商户${row.username}的密码？`,
        onOk: () => {
          // this.$Message.info('您点击了确定.');
          this.resetPassword(row);
        },
        onCancel: () => {
          this.$Message.info('您点击了取消.');
        }
      });
    },
    // 是否删除租户
    isDelUser(row) {
      // console.log(row)
      this.$Modal.confirm({
        title: `是否删除租户${row.username}？`,
        onOk: () => {
          // this.$Message.info('您点击了确定.');
          this.deleteAdmin(row);
        },
        onCancel: () => {
          this.$Message.info('您点击了取消.');
        }
      });
    },
    // 是否禁用租户
    isDisableUser(row) {
      // console.log(row)
      this.$Modal.confirm({
        title: `是否${row.isDisable ? '开启' : '禁用'}租户${row.username}？`,
        onOk: () => {
          this.disableAdmin(row);
        },
        onCancel: () => {
          this.$Message.info('您点击了取消.');
        }
      });
    },
    updateMessage(row) {
      this.$Spin.show();
      this.axios.post('/tenant/updateMessage', {
        tenantId: row.tenantId
      }).then(res => {
        console.log(res);
        setTimeout(() => {
          this.$Spin.hide();
        }, 300);
        if (res.status == 200) {
          this.$Message.success('操作成功.');
        }
        if (res.status == 500) {
          this.$Notice.error({
            title: '服务器内部错误',
            desc: '更新消息提醒接口报错',
            duration: 0
          });
        }
      })
    },
    // 重置租户密码
    resetPassword(row) {
      this.$Spin.show();
      this.axios.post('/adminUser/resetPassword', {
        adminId: row.adminId
      }).then(res => {
        console.log(res);
        setTimeout(() => {
          this.$Spin.hide();
        }, 300);
        if (res.status == 200) {
          this.$Message.success('操作成功.');
        }
        if (res.status == 500) {
          this.$Notice.error({
            title: '服务器内部错误',
            desc: '重置租户密码接口报错',
            duration: 0
          });
        }
      })
    },
    showRecord(row) {
      this.$refs.recordOpe.show(row);
    },
    // 删除租户
    deleteAdmin(row) {
      this.$Spin.show();
      this.axios.post('/tenant/delete', {
        tenantId: row.tenantId
      }).then(res => {
        setTimeout(() => {
          this.$Spin.hide();
        }, 300);
        if (res.status == 200) {
          this.$Message.success('操作成功.');
          this.findList();
        }
        if (res.status == 201) {
          // this.$Message.error(res.msg);
          this.$Notice.error({
            title: '删除租户失败',
            desc: res.msg
          });
        }
        if (res.status == 500) {
          this.$Notice.error({
            title: '服务器内部错误',
            desc: '删除租户接口报错',
            duration: 0
          });
        }
      })
    },
    // 禁用或开启租户
    disableAdmin(row) {
      this.$Spin.show();
      this.axios.post('/tenant/disable', {
        tenantId: row.tenantId,
        isDisable: row.isDisable ? 0 : 1
      }).then(res => {
        console.log(res);
        setTimeout(() => {
          this.$Spin.hide();
        }, 300);
        if (res.status == 200) {
          this.$Message.success('操作成功.');
          this.findList();
        }
        if (res.status == 500) {
          this.$Notice.error({
            title: '服务器内部错误',
            desc: '禁用区域商户接口报错',
            duration: 0
          });
        }
      })
    },
    // 显示操作模态框
    showAdminOpe(type, row) {
      /**
       * type判断
       * 1.查看 2.新增 3.编辑
       */
      this.$refs.tenantOpe.show(type, row);
    },
    // 打开充值模态框
    showRecharge(row) {
      this.$refs.rechargeOpe.show(row);
    },
    // 重置筛选条件
    resetScreen() {
      this.params.realName = '';
    },
    // 改变页数
    changePage(e) {
      this.params.page = e;
      this.findList();
    },
    // 改变页容量
    changePageSize(e) {
      this.params.rows = e;
      this.findList();
    },
  },
  components: {
    hsBreadcrumb,
    tenantOpe,
    rechargeOpe,
    recordOpe
  }
}
</script>

<style scoped>

</style>